<div class="form-group time-field">
  <label class="form-label">{{ label }}</label>
  <div class="time-input-wrapper" [class.disabled]="isDisabled">
    <img src="assets/images/svg/clock.svg" alt="clock" class="clock-icon" />
    <input #time type="time" lang="ar" [ngModel]="timeValue"
      (ngModelChange)="ontimeChange($event)" class="time-input form-control"
      (click)="$any(time).showPicker?.()" [disabled]="isDisabled" />
    <span class="time-display">{{ timeValue | arabicTimeFormat }}</span>
  </div>
</div>
